import React from 'react';
import './link.scss'

const Link = (props) => {
    return (
        props.modal ? (
            <a className="link" onClick={props.modal}>{props.name}</a>
        ) : (
            <a className="link" href={decodeURIComponent(props.url)}>{props.name}</a>
        )
    )
};

export default Link;
